import React, { FC } from 'react'

import css from './LookBookItem.module.scss'
import Link from 'next/link'
import { ILookBookItem } from '../../types'
import Image from '../../common/Image/Image'
interface IILookBookItemProps {
  look: ILookBookItem
  index: number
}

const LookBookItem: FC<IILookBookItemProps> = ({ look, index }) => {
  return (
    <li className={css.wrapper}>
      <Link href={look.link} passHref>
        <a className={css.item}>
          <Image
            src={look.img}
            alt={look.name}
            layout="responsive"
            width={600}
            height={720}
            objectFit="cover"
            loading={index > -1 && index < 4 ? 'eager' : 'lazy'}
            priority={index === 0}
          />
          <p className={css.title}>
            <span className={css.heading}>{look.name}</span>
          </p>
        </a>
      </Link>
    </li>
  )
}

export default LookBookItem
